import React, { Fragment, PureComponent } from 'react';
import { formatCondensedHumanDate } from '~/DateTime';
import Price from '~/utils/Price';
import {
	Sentence as ApiSentence,
	SentencePart,
	SentencePartType,
} from '~/MedicinalBrandsAnalytics/VirtualBrand/History';
import Tooltip from '~/UI/Tooltip';
import DarkTooltipStyles from '~/UI/Tooltip/dark.less';

import styles from './styles.less';

interface Props {
	sentence: ApiSentence;
}

export default class Sentence extends PureComponent<Props> {
	renderPart(part: SentencePart) {
		switch (part.type) {
			case SentencePartType.countryName:
			case SentencePartType.virtualBrandName:
				return <strong>{part.name}</strong>;

			case SentencePartType.virtualPackageName:
				return part.name;

			case SentencePartType.dataSourceName:
				return part.shortName;

			case SentencePartType.text:
				return part.emphasis ? <strong>{part.text}</strong> : part.text;

			case SentencePartType.tooltip:
				return (
					<Tooltip reference={<u>{part.text}</u>} styles={DarkTooltipStyles}>
						<p className={styles.tooltipContent}>{part.tooltip}</p>
					</Tooltip>
				);

			case SentencePartType.monetaryAmount:
				return <strong>{new Price(part.amount, part.currency).roundedHumanFormat()}</strong>;

			case SentencePartType.date:
				return formatCondensedHumanDate(new Date(part.date));

			case SentencePartType.month:
				return <strong>{part.month}</strong>;

			case SentencePartType.collapsedPartsList:
				return part.collapsedParts.length === 1 ? (
					<Fragment>({this.renderPart(part.collapsedParts[0])})</Fragment>
				) : (
					<Tooltip reference={<u>({part.collapsedParts.length})</u>} styles={DarkTooltipStyles}>
						{/* eslint-disable-next-line react/no-array-index-key */}
						{part.collapsedParts.map((part, i) => (
							<p className={styles.tooltipContent} key={`${JSON.stringify(part)}-${i}`}>
								{this.renderPart(part)}
							</p>
						))}
					</Tooltip>
				);

			default:
				return '';
		}
	}

	render() {
		const { sentence } = this.props;
		const lastIndex = sentence.parts.length - 1;

		return sentence.parts.map((part, i) => (
			<Fragment key={`${JSON.stringify(part)}-${i}`}>
				{i > 0 ? ' ' : null}
				{this.renderPart(part)}
				{i === lastIndex ? '.' : null}
			</Fragment>
		));
	}
}
